import { FC } from 'react';
import cx from 'clsx';
import { MutatingDots } from 'react-loader-spinner';

import mainStyles from '../../styles.module.css';
import styles from './styles.module.css';
import { useCapturedStep } from './useCapturedStep';

export const CapturedStep: FC = () => {
  const { capturedMessage, capturedMessageKey } = useCapturedStep();

  return (
    <section className={cx(mainStyles.stepSection, styles.container)}>
      <h3 className={styles.title}>Nice!</h3>
      <h3 className={styles.message} key={capturedMessageKey}>
        {capturedMessage}
      </h3>

      <MutatingDots
        height="100"
        width="100"
        color="white"
        secondaryColor="white"
        radius="12.5"
        ariaLabel="captured-step-loader"
        visible={true}
      />
    </section>
  );
};
